import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="mt-40 mx-auto text-center">
      <p className="mt-4 mb-6">
        <Link to="/">
          <span className="text-lg text-slate-700 dark:text-gray-200 underline underline-offset-2 decoration-2 decoration-sky-500">
            Hallo
          </span>
        </Link>
        <span className="dark:text-gray-200"> - </span>
        <Link to="/karya">
          <span className="text-lg text-slate-700 dark:text-gray-200 underline underline-offset-2 decoration-2 decoration-sky-500">
            Karya
          </span>
        </Link>
        <span className="dark:text-gray-200"> - </span>
        <Link to="/kontak">
          <span className="text-lg text-slate-700 dark:text-gray-200 underline underline-offset-2 decoration-2 decoration-sky-500">
            Kontak
          </span>
        </Link>
        <span className="dark:text-gray-200"> - </span>
        <Link to="/motivasi">
          <span className="text-lg text-slate-700 dark:text-gray-200 underline underline-offset-2 decoration-2 decoration-sky-500">
            🌈
          </span>
        </Link>
      </p>
    </div>
  );
}

export default Footer;
